export default __webpack_public_path__ + "static/bluer-3b87edb14b9ac06fa667ac0598c31259.webp";